import { trpc } from '@/shared/api';

const USERS_PAGE_SIZE = 20;

interface UsersListParams {
  readonly page: number;
  readonly search: string;
}

/** 관리자 사용자 목록 조회 — 빈 검색어는 입력에서 제외한다(서버 계약). */
export const useUsersListQuery = ({ page, search }: UsersListParams) =>
  trpc.users.list.useQuery({
    page,
    limit: USERS_PAGE_SIZE,
    ...(search ? { search } : {}),
  });
